import {ItemCRM} from "@/api/CRM/itemCRM";

export class ClientCRM extends ItemCRM {
  method = 'clients';
}
